var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 11.6666H19.6666L15.7999 15.3C14.9043 16.1961 13.7963 16.8506 12.5792 17.2027C11.3622 17.5547 10.0758 17.5927 8.84016 17.3131C7.60447 17.0335 6.45975 16.4455 5.51281 15.6038C4.56586 14.7621 3.84756 13.6943 3.42492 12.5M19.6666 16.6666V15M1.33325 3.33331V8.33332L5.19992 4.69998C6.09554 3.80391 7.20356 3.14932 8.42059 2.79729C9.63762 2.44527 10.924 2.40727 12.1597 2.68686C13.3954 2.96645 14.5401 3.55451 15.487 4.39616C16.434 5.23782 17.1523 6.30564 17.5749 7.49998M4.66658 8.33332H6.33325",
    stroke: "#A94FE6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.44193f271a7980c4b8d3bc9cab1acd9f.svg";
export { ForwardRef as ReactComponent };